var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounWildwest924480(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{stroke:#000000;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4,
    cy: 67.4,
    r: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 72.4,
    r: 1.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9,
    cy: 69.5,
    r: 1.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 73,
    r: 1.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 74.4,
    r: 1.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.2,
    cy: 68.1,
    r: 1.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9,
    cy: 67.4,
    r: 1.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9,
    cy: 68.4,
    r: 1.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6,
    cy: 71.6,
    r: 1.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.2,
    cy: 74.4,
    r: 1.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 67.5,
    r: 1.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9,
    cy: 68.1,
    r: 1.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9,
    cy: 78,
    r: 1.4
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 84,
    r: 1.4
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.3,
    cy: 80.1,
    r: 1.4
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 83.6,
    r: 1.4
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9,
    cy: 85.1,
    r: 1.4
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.6,
    cy: 78.7,
    r: 1.4
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.3,
    cy: 78,
    r: 1.4
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.3,
    cy: 79.1,
    r: 1.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1,
    cy: 82.2,
    r: 1.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.6,
    cy: 85.1,
    r: 1.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 78.2,
    r: 1.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.042121e-02 -0.9982 0.9982 6.042121e-02 -7.781438e-02 146.5383)",
    cx: 77.8,
    cy: 73.3,
    rx: 1.4,
    ry: 1.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.039983e-02 -0.9982 0.9982 6.039983e-02 -7.5892 129.2667)",
    cx: 64.9,
    cy: 68.7,
    rx: 1.4,
    ry: 1.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.042121e-02 -0.9982 0.9982 6.042121e-02 0.3269 135.6977)",
    cx: 72.2,
    cy: 67.7,
    rx: 1.4,
    ry: 1.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.039983e-02 -0.9982 0.9982 6.039983e-02 13.0852 149.4846)",
    cx: 85.9,
    cy: 67.8,
    rx: 1.4,
    ry: 1.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.040396e-02 -0.9982 0.9982 6.040396e-02 -13.9148 134.9229)",
    cx: 64.7,
    cy: 74.9,
    rx: 1.1,
    ry: 1.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.040396e-02 -0.9982 0.9982 6.040396e-02 -5.6823 138.6789)",
    cx: 70.8,
    cy: 72.4,
    rx: 1.1,
    ry: 1.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.040568e-02 -0.9982 0.9982 6.040568e-02 6.4772 152.6581)",
    cx: 84.3,
    cy: 72.9,
    rx: 1.1,
    ry: 1.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.040568e-02 -0.9982 0.9982 6.040568e-02 -18.0213 126.8701)",
    cx: 58.4,
    cy: 73,
    rx: 1.1,
    ry: 1.1
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.040568e-02 -0.9982 0.9982 6.040568e-02 6.8964 142.4332)",
    cx: 79.1,
    cy: 67.6,
    rx: 1.1,
    ry: 1.1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.3,
    cy: 78.7,
    r: 1.1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 85.4,
    r: 1.4
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3,
    cy: 85,
    r: 1.4
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1,
    cy: 81.2,
    r: 1.4
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.3,
    cy: 85,
    r: 1.4
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4,
    cy: 79.7,
    r: 1.4
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1,
    cy: 79,
    r: 1.4
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9,
    cy: 86.5,
    r: 1.1
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4,
    cy: 86.1,
    r: 1.1
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3,
    cy: 79.2,
    r: 1.1
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8,
    cy: 74.7,
    r: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9,61.1h-7.8c3.9-2.4,5.2-6.7,5.2-6.9c0.1-0.5-0.2-1.1-0.7-1.2c-0.5-0.1-1.1,0.2-1.2,0.7c0,0-0.9,3.2-3.6,5.2v-9.9  c0-0.6-0.4-1-1-1s-1,0.4-1,1V59c-2.8-2-3.8-5.3-3.8-5.4c-0.2-0.5-0.7-0.8-1.2-0.7c-0.5,0.2-0.8,0.7-0.7,1.2c0.1,0.2,1.3,4.5,5.2,6.9  H58.9c2.4-0.6,5-1.7,7.1-3.7c5.3-5.1,4.8-14,4.7-14.4c0-0.5-0.4-0.9-0.9-0.9c-0.4,0-9.2-0.8-14.5,4.3c-1.2,1.2-2.1,2.5-2.8,3.9v-8.5  c0,0,0.1,0,0.1,0c2.1,0,6.5-0.4,9.4-3.2c3.9-3.7,3.5-10.2,3.5-10.4c0-0.5-0.4-0.9-0.9-0.9c-0.3,0-6.7-0.6-10.5,3.1  c-0.6,0.6-1.1,1.2-1.5,1.9v-4.7c0.9-0.9,3.7-3.8,3.6-7.5c0-4.2-3.9-7.5-4.1-7.7c-0.4-0.3-0.9-0.3-1.3,0c-0.2,0.1-4,3.5-3.9,7.7  c0,3.5,2.6,6.3,3.7,7.3V32c-0.3-0.5-0.7-1-1.2-1.5c-3.7-3.9-10.2-3.5-10.4-3.5c-0.5,0-0.9,0.4-0.9,0.9c0,0.3-0.6,6.7,3.1,10.5  c2.9,3,7.4,3.4,9.4,3.5v8.3c-0.7-1.4-1.6-2.8-2.8-3.9c-5.3-5.1-14.1-4.3-14.5-4.3c-0.5,0-0.9,0.4-0.9,0.9c0,0.4-0.5,9.2,4.7,14.4  c2.1,2,4.7,3.1,7.1,3.7h-21c3.9-2.4,5.2-6.7,5.2-6.9c0.1-0.5-0.2-1.1-0.7-1.2c-0.5-0.1-1.1,0.2-1.2,0.7c0,0-0.9,3.2-3.6,5.2v-9.9  c0-0.6-0.4-1-1-1s-1,0.4-1,1V59c-2.8-2-3.8-5.3-3.8-5.4c-0.2-0.5-0.7-0.8-1.2-0.7c-0.5,0.2-0.8,0.7-0.7,1.2c0.1,0.2,1.3,4.5,5.2,6.9  h-7.7c-0.6,0-1,0.4-1,1s0.4,1,1,1h77.3c0.6,0,1-0.4,1-1S90.5,61.1,89.9,61.1z M55.5,31.8c2.4-2.3,6.2-2.6,8-2.6c0,0,0,0,0,0  c0,1.7-0.4,5.6-2.9,8c-2.4,2.3-6.2,2.6-8,2.6c0,0,0,0,0,0C52.7,38.1,53,34.2,55.5,31.8z M38.5,55.9c-3.7-3.6-4.1-9.7-4.2-11.9  c2.3,0,8.3,0.2,12,3.8c3.7,3.6,4.1,9.7,4.2,11.9C48.3,59.8,42.3,59.5,38.5,55.9z M50.6,40c-1.8,0-5.6-0.4-8-2.9  c-2.4-2.4-2.6-6.3-2.6-8.1c1.7,0,5.6,0.4,8,2.9c2,2.1,2.5,5.3,2.6,7.2V40z M48.9,20.2c0-2.4,1.6-4.5,2.6-5.6c1,1,2.7,3.1,2.7,5.5  c0,2.4-1.6,4.5-2.6,5.6C50.7,24.7,49,22.6,48.9,20.2z M52.6,59.7c0-2.3,0.4-8.3,4.2-11.9c3.7-3.6,9.8-3.8,12-3.8  c0,2.3-0.4,8.3-4.2,11.9C60.9,59.5,54.8,59.8,52.6,59.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounWildwest924480);
export default __webpack_public_path__ + "static/media/noun_wild west_924480.246aa535.svg";
export { ForwardRef as ReactComponent };